import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Text from '@/storybook/components/Text/Text';
import AILogoGradientIcon from '@/storybook/icons/AILogoGradientIcon';
import { type AIFilterChip } from '../AIFilterChips/AIFilterChips';
import CollapsibleFilterGroup from '../CollapsibleFilterGroup/CollapsibleFilterGroup';
import { CHAT_FILTER_HEADER_TEST_IDS } from './testIds';
import styles from './ChatFilterHeader.module.css';

export interface ChatFilterHeaderProps {
  globalFilters: ReadonlyArray<AIFilterChip>;
  localFilters: ReadonlyArray<AIFilterChip>;
}

const ChatFilterHeader: FC<ChatFilterHeaderProps> = ({ globalFilters, localFilters }) => {
  const { t } = useTranslation();

  if (globalFilters.length === 0 && localFilters.length === 0) {
    return null;
  }

  return (
    <section
      className={styles.container}
      aria-label={t('components.aiChatDrawer.filterHeader.ariaLabel')}
      data-testid={CHAT_FILTER_HEADER_TEST_IDS.container}
    >
      <div className={styles.contentRow}>
        <div className={styles.avatar} aria-hidden="true">
          <AILogoGradientIcon className={styles.avatarIcon} />
        </div>
        <div className={styles.filterRow}>
          <Text as="span" className={styles.title} data-testid={CHAT_FILTER_HEADER_TEST_IDS.title}>
            {t('components.aiChatDrawer.filterHeader.title')}
          </Text>
          <CollapsibleFilterGroup
            label={t('components.aiChatDrawer.filterHeader.globalLabel')}
            filters={globalFilters}
            dataTestId={CHAT_FILTER_HEADER_TEST_IDS.global}
          />
          <CollapsibleFilterGroup
            label={t('components.aiChatDrawer.filterHeader.localLabel')}
            filters={localFilters}
            dataTestId={CHAT_FILTER_HEADER_TEST_IDS.local}
          />
        </div>
      </div>
    </section>
  );
};

export default ChatFilterHeader;
